var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fcfcfc",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 395 395",
    xmlSpace: "preserve",
    stroke: "#fcfcfc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M232.208,288.822h-5.393l0.048-121.618c-0.165-8.301-6.934-14.983-15.276-14.983h-48.795 c-8.446,0-15.292,6.847-15.292,15.29c0,8.446,6.846,15.292,15.292,15.292h8.376v106.019h-5.393c-8.446,0-15.292,6.846-15.292,15.29 c0,8.447,6.846,15.292,15.292,15.292h66.433c8.446,0,15.292-6.845,15.292-15.292C247.5,295.668,240.654,288.822,232.208,288.822z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.029,
    cy: 107.708,
    r: 32.112
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.001,0H81.999C36.785,0,0,36.784,0,81.998v230.993C0,358.211,36.785,395,81.999,395h231.002 C358.216,395,395,358.211,395,312.991V81.998C395,36.784,358.216,0,313.001,0z M380,312.991C380,349.94,349.945,380,313.001,380 H81.999C45.056,380,15,349.94,15,312.991V81.998C15,45.055,45.056,15,81.999,15h231.002C349.945,15,380,45.055,380,81.998V312.991z "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSign);
export default __webpack_public_path__ + "static/media/info_sign.80493f1123ec189681d7e5c9eadd76a2.svg";
export { ForwardRef as ReactComponent };